import React from "react";
import Image from "next/image";
import { type EventsPagePartner } from "lib/sanity";
import { Flex, Text, Box } from "@chakra-ui/react";
import { Section } from "components/section";
import { Logo } from "components/brand/logo";
import { Link } from "ui/link";

export function EventPartners({ partners }: { partners: EventsPagePartner[] }) {
  return (
    <Section my="biggest">
      <Text as="h2" textStyle="headline3">
        Hosted by
      </Text>
      <Flex
        align="center"
        justify="start"
        mt={8}
        gap={10}
        wrap={partners.length > 2 ? { base: "wrap", xl: "nowrap" } : "nowrap"}
      >
        <Link aria-label="Hightouch." href="/" target="_blank" width={{ base: "120px", lg: "160px" }}>
          <Logo width="100%" />
        </Link>

        {partners.map((partner) => (
          <Link key={partner.slug} aria-label={`Go to ${partner.name} website.`} href={partner.website} target="_blank">
            <Box pos="relative" w="100%" maxW={{ base: "120px", lg: "160px" }}>
              <Image
                src={`${partner.logoUrl}?w=320`}
                alt={`${partner.name}.`}
                sizes="100%"
                width={120}
                height={40}
                style={{
                  objectFit: "contain",
                  width: "auto",
                  maxWidth: "100%",
                  height: "40px",
                }}
              />
            </Box>
          </Link>
        ))}
      </Flex>
    </Section>
  );
}
